import React from 'react';
// آیکن ستاره نیمه را اضافه می‌کنیم
import {FaStar, FaRegStar, FaStarHalfAlt} from 'react-icons/fa';


const StarRating = ({ score }) => {
    // اطمینان از اینکه امتیاز عددی بین ۰ تا ۵ است
    const validScore = Math.max(0, Math.min(5, Number(score) || 0));

    return (
        <div className="star-rating" dir="ltr">
            {[...Array(5)].map((_, index) => {
                const starNumber = index + 1;

                // بررسی برای نمایش ستاره کامل، نیمه یا خالی
                if (validScore >= starNumber) {
                    // اگر امتیاز بزرگتر یا مساوی شماره ستاره باشد، ستاره کامل است
                    return <FaStar key={index} />;
                } else if (validScore >= starNumber - 0.5) {
                    // در غیر این صورت، اگر امتیاز بزرگتر از شماره ستاره منهای نیم باشد، ستاره نیمه است
                    return <FaStarHalfAlt key={index} />;
                } else {
                    // در غیر این صورت، ستاره خالی است
                    return <FaRegStar key={index} />;
                }
            })}
        </div>
    );
};

export default StarRating;
